var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 16a3.067 3.067 0 01-1.04 2.305L10.091 31.386a2.462 2.462 0 01-3.251-3.698l13.003-11.439a.334.334 0 000-.501L6.84 4.309A2.463 2.463 0 0110.092.611l14.864 13.077a3.079 3.079 0 011.045 2.309z"
  })));
}
export default SvgArrowRight;